import React, { FC, useEffect, useState } from 'react';
import PageTitle from '../../page-title';
import { useIsMobile } from '../../../../util/style-utils';
import { BlogArticleFragment } from '../../../../__generated__/gatsby-types';
import Mobile from './layout/Mobile';
import Desktop from './layout/Desktop';

interface Props {
  title: string;
  articleData: any;
  featured: any;
}

const RecentPosts: FC<Props> = (props: Props) => {
  const { title, articleData, featured } = props;
  const isMobile = useIsMobile();

  const [recentArticles, setRecentArticles] = useState<BlogArticleFragment[]>([]);
  const [spotlightArticle, setSpotlightArticle] = useState<BlogArticleFragment>();

  useEffect(() => {
    if (articleData && articleData?.length > 0) {
      const carouselArticles = featured?.carouselArticles as BlogArticleFragment[];
      setSpotlightArticle(featured?.spotlightArticle);

      if (!carouselArticles?.length && !spotlightArticle?.id) {
        setRecentArticles(articleData);
        return;
      }
      
      // If there are any featured articles, filter them out of the recent articles collection. 
      // - Carousel articles are handled in the parent page/template.
      // - Spotlight articles are handled seperately in the child layout (Desktop/Mobile).
      const featuredArticles: Set<string> = new Set();

      carouselArticles?.forEach(article => featuredArticles.add(article.id))

      if(featured?.spotlightArticle?.id) {
        featuredArticles.add(featured.spotlightArticle.id);
      }

      setRecentArticles(articleData.filter((article: any) => {
        return !featuredArticles.has(article.id);
        })
      );
    }
  }, []);

  return (
    <>
      {recentArticles.length ? (
        <>
          <PageTitle
            title={title}
            subHeading
            style={{
              marginTop: isMobile ? 20 : 30,
              padding: isMobile ? '0 20px' : '0',
            }}
          />
          {isMobile ? (
            <Mobile
            articles={recentArticles}
            spotlightArticle={spotlightArticle}
            />
          ) : (
            <Desktop
            articles={recentArticles}
            spotlightArticle={spotlightArticle}
            />
          )}
        </>
      ) : null}
    </>
  );
};

export default RecentPosts;
